import { View, ViewProps } from 'react-native';
import { CreateResponsiveStyle, DEVICE_SIZES, minSize } from 'rn-responsive-styles';

import { Button } from '../Button';
import { Text } from '../Text';
import { colors, spacing } from '../../theme';
import { Lock } from './Lock';

interface Props extends ViewProps {
	title: string;
	subtitle?: string;
	status?: 'primary' | 'danger';
	onPress?: () => void;
}

export const ActionRow = ({
	title,
	subtitle,
	status = 'primary',
	onPress,
	...viewProps
}: Props) => {
	const styles = useStyles();

	return (
		<View style={styles.root} {...viewProps}>
			<View style={styles.content}>
				<Lock status={status} />
				<View style={styles.titles}>
					<Text category="h5">{title}</Text>
					{subtitle && <Text category="c1">{subtitle}</Text>}
				</View>
			</View>

			<Button variant="filled" color={status} onPress={onPress}>
				{title}
			</Button>
		</View>
	);
};

const useStyles = CreateResponsiveStyle(
	{
		root: {
			flexDirection: 'column',
			gap: spacing(),
			width: '100%',
			borderRadius: spacing(2),
			padding: spacing(3),
			justifyContent: 'space-between',
			borderWidth: 1,
			borderColor: colors.primaryDisabled,
		},
		content: {
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			gap: spacing(2),
		},
		titles: {
			flexDirection: 'column',
			justifyContent: 'space-between',
			gap: spacing(),
			flex: 1,
		},
	},
	{
		[minSize(DEVICE_SIZES.MD)]: {
			root: {
				flexDirection: 'row',
				alignItems: 'center',
			},
			titles: {
				flex: 1,
			},
		},
	},
);
